import { Button, TextField, Select, MenuItem } from "@mui/material";
import SelectUpload from "../../Modals/select_upload";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from '@mui/icons-material/Close';


const HomePageBanners = () => {
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => setOpenModal(false);

    const [slider1, setSlider1] = useState([{ id: Date.now() }]);
    const [slider2, setSlider2] = useState([{ id: Date.now() }]);

    const addSlide1 = () => setSlider1([...slider1, { id: Date.now() }]);
    const removeSlide1 = (id: number) => setSlider1(slider1.filter(s => s.id !== id));

    const addSlide2 = () => setSlider2([...slider2, { id: Date.now() }]);
    const removeSlide2 = (id: number) => setSlider2(slider2.filter(s => s.id !== id));


    return (
        <>
            <div className="main_title d_flex">
                <h1>Manage Home Page Banners</h1>
                <div className="right_">
                    <div className="form_btn">
                        <Button className="btn btn_primary">Save & Update</Button>
                    </div>
                </div>
            </div>

            {/* Hero Banner Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Hero Banner Section</h2>

                </div>

                <form className="form">
                    <div className="gap_m">
                        {/* Upload Banner Video/Image */}
                        <div className="control_group w_100">
                            <label htmlFor="hero_upload_btn">Banner Video/Image</label>
                            <div className="upload_box">
                                <button type="button" id="hero_upload_btn" className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                    <p>
                                        <img src="/static/images/upload_icon.svg" alt="icon" />
                                        <strong>Click to upload Video/Image</strong>
                                    </p>
                                </button>
                            </div>
                        </div>

                        {/* Title */}
                        <div className="control_group w_33">
                            <label htmlFor="hero_title">Title</label>
                            <TextField
                                id="hero_title"
                                placeholder="Enter Title"
                                fullWidth
                                hiddenLabel
                            />
                        </div>
                        <div className="control_group w_33">
                            <label htmlFor="hero_link">Link</label>
                            <TextField
                                id="hero_link"
                                placeholder="Enter Link"
                                fullWidth
                                hiddenLabel
                            />
                        </div>
                        <div className="control_group w_33">
                            <label htmlFor="hero_collection">Collection</label>
                            <Select
                                id="hero_collection"
                                fullWidth
                                displayEmpty
                                defaultValue=""
                            >
                                <MenuItem value="" disabled>Select Collection</MenuItem>
                                <MenuItem value="summer">Summer Collection</MenuItem>
                                <MenuItem value="winter">Winter Collection</MenuItem>
                                <MenuItem value="autumn">Autumn Collection</MenuItem>
                                <MenuItem value="spring">Spring Collection</MenuItem>
                            </Select>
                        </div>

                        {/* Description */}
                        <div className="control_group w_33">
                            <label htmlFor="hero_desc">Description</label>
                            <TextField
                                id="hero_desc"
                                placeholder="Enter Description"
                                fullWidth
                                multiline
                                rows={2}
                                hiddenLabel
                            />
                        </div>

                        {/* Button Text */}
                        <div className="control_group w_33">
                            <label htmlFor="hero_btn">Button Text</label>
                            <TextField
                                id="hero_btn"
                                placeholder="Enter Button Text"
                                fullWidth
                                hiddenLabel
                            />
                        </div>
                    </div>
                </form>
            </div>

            {/* Middle Sliding Banners Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Middle Sliding Banners</h2>
                </div>

                <div className="gap_m flex">
                    {/* Slider 1 */}
                    <div className="w_100 form">
                        <div className="title_inner">
                            <h3>Sliding Banner Group 1</h3>
                            <Button className="btn btn_primary sm" onClick={addSlide1}>
                                <AddIcon /> Add Slide
                            </Button>
                        </div>
                        <div className="gap_p">
                            {slider1.map((s, index) => (
                                <><div key={s.id} className="control_group w_100 mb_20" style={{ position: 'relative', padding: '15px', background: '#f9f9f9', borderRadius: '8px' }}>
                                    {slider1.length > 1 && (
                                        <CloseIcon
                                            onClick={() => removeSlide1(s.id)}
                                            style={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer', color: '#ef4444', fontSize: '18px' }} />
                                    )}
                                    <label htmlFor={`slide1_upload_${s.id}`}>Slide {index + 1} Image/Video</label>
                                    <div className="upload_box">
                                        <button type="button" id={`slide1_upload_${s.id}`} className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                            <p>
                                                <img src="/static/images/upload_icon.svg" alt="icon" />
                                                <strong>Click to upload</strong>
                                            </p>
                                        </button>
                                    </div>
                                </div>
                                    <div className="control_group w_33">
                                        <label htmlFor={`slide1_link_${s.id}`}>Link</label>
                                        <TextField
                                            id={`slide1_link_${s.id}`}
                                            placeholder="Enter Link"
                                            fullWidth
                                            hiddenLabel />
                                    </div>
                                    <div className="control_group w_33">
                                        <label htmlFor={`slide1_collection_${s.id}`}>Collection</label>
                                        <Select
                                            id={`slide1_collection_${s.id}`}
                                            fullWidth
                                            displayEmpty
                                            defaultValue=""
                                        >
                                            <MenuItem value="" disabled>Select Collection</MenuItem>
                                            <MenuItem value="summer">Summer Collection</MenuItem>
                                            <MenuItem value="winter">Winter Collection</MenuItem>
                                            <MenuItem value="autumn">Autumn Collection</MenuItem>
                                            <MenuItem value="spring">Spring Collection</MenuItem>
                                        </Select>
                                    </div>
                                </>

                            ))}
                        </div>
                    </div>

                    {/* Slider 2 */}
                    <div className="w_100 form">
                        <div className="title_inner">
                            <h3>Sliding Banner Group 2</h3>
                            <Button className="btn btn_primary sm" onClick={addSlide2}>
                                <AddIcon /> Add Slide
                            </Button>
                        </div>
                        <div className="gap_p">
                            {slider2.map((s, index) => (
                                <><div key={s.id} className="control_group w_100 mb_20" style={{ position: 'relative', padding: '15px', background: '#f9f9f9', borderRadius: '8px' }}>
                                    {slider2.length > 1 && (
                                        <CloseIcon
                                            onClick={() => removeSlide2(s.id)}
                                            style={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer', color: '#ef4444', fontSize: '18px' }} />
                                    )}
                                    <label htmlFor={`slide2_upload_${s.id}`}>Slide {index + 1} Image/Video</label>
                                    <div className="upload_box">
                                        <button type="button" id={`slide2_upload_${s.id}`} className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                            <p>
                                                <img src="/static/images/upload_icon.svg" alt="icon" />
                                                <strong>Click to upload</strong>
                                            </p>
                                        </button>
                                    </div>
                                </div>
                                    <div className="control_group w_33">
                                        <label htmlFor={`slide2_link_${s.id}`}>Link</label>
                                        <TextField
                                            id={`slide2_link_${s.id}`}
                                            placeholder="Enter Link"
                                            fullWidth
                                            hiddenLabel />
                                    </div>
                                    <div className="control_group w_33">
                                        <label htmlFor={`slide2_collection_${s.id}`}>Collection</label>
                                        <Select
                                            id={`slide2_collection_${s.id}`}
                                            fullWidth
                                            displayEmpty
                                            defaultValue=""
                                        >
                                            <MenuItem value="" disabled>Select Collection</MenuItem>
                                            <MenuItem value="summer">Summer Collection</MenuItem>
                                            <MenuItem value="winter">Winter Collection</MenuItem>
                                            <MenuItem value="autumn">Autumn Collection</MenuItem>
                                            <MenuItem value="spring">Spring Collection</MenuItem>
                                        </Select>
                                    </div>
                                </>

                            ))}
                        </div>
                    </div>
                </div>
            </div>


            {/* Category Page Banners Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Category Page Banners</h2>
                </div>

                <div className="gap_m flex">
                    {/* Banner 1 */}
                    <div className="w_100 form">
                        <div className="title_inner">
                            <h3>Banner 1</h3>
                        </div>
                        <div className="gap_p">
                            <div className="control_group w_100 mb_20" style={{ position: 'relative', padding: '15px', background: '#f9f9f9', borderRadius: '8px' }}>
                                <label htmlFor="cat_banner_upload_1">Banner 1 Image/Video</label>
                                <div className="upload_box">
                                    <button type="button" id="cat_banner_upload_1" className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                        <p>
                                            <img src="/static/images/upload_icon.svg" alt="icon" />
                                            <strong>Click to upload</strong>
                                        </p>
                                    </button>
                                </div>
                            </div>
                            <div className="control_group w_33">
                                <label htmlFor="cat_banner_link_1">Link</label>
                                <TextField
                                    id="cat_banner_link_1"
                                    placeholder="Enter Link"
                                    fullWidth
                                    hiddenLabel />
                            </div>
                            <div className="control_group w_33">
                                <label htmlFor="cat_banner_col_1">Collection</label>
                                <Select
                                    id="cat_banner_col_1"
                                    fullWidth
                                    displayEmpty
                                    defaultValue=""
                                >
                                    <MenuItem value="" disabled>Select Collection</MenuItem>
                                    <MenuItem value="summer">Summer Collection</MenuItem>
                                    <MenuItem value="winter">Winter Collection</MenuItem>
                                    <MenuItem value="autumn">Autumn Collection</MenuItem>
                                    <MenuItem value="spring">Spring Collection</MenuItem>
                                </Select>
                            </div>
                        </div>
                    </div>

                    {/* Banner 2 */}
                    <div className="w_100 form">
                        <div className="title_inner">
                            <h3>Banner 2</h3>
                        </div>
                        <div className="gap_p">
                            <div className="control_group w_100 mb_20" style={{ position: 'relative', padding: '15px', background: '#f9f9f9', borderRadius: '8px' }}>
                                <label htmlFor="cat_banner_upload_2">Banner 2 Image/Video</label>
                                <div className="upload_box">
                                    <button type="button" id="cat_banner_upload_2" className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                        <p>
                                            <img src="/static/images/upload_icon.svg" alt="icon" />
                                            <strong>Click to upload</strong>
                                        </p>
                                    </button>
                                </div>
                            </div>
                            <div className="control_group w_33">
                                <label htmlFor="cat_banner_link_2">Link</label>
                                <TextField
                                    id="cat_banner_link_2"
                                    placeholder="Enter Link"
                                    fullWidth
                                    hiddenLabel />
                            </div>
                            <div className="control_group w_33">
                                <label htmlFor="cat_banner_col_2">Collection</label>
                                <Select
                                    id="cat_banner_col_2"
                                    fullWidth
                                    displayEmpty
                                    defaultValue=""
                                >
                                    <MenuItem value="" disabled>Select Collection</MenuItem>
                                    <MenuItem value="summer">Summer Collection</MenuItem>
                                    <MenuItem value="winter">Winter Collection</MenuItem>
                                    <MenuItem value="autumn">Autumn Collection</MenuItem>
                                    <MenuItem value="spring">Spring Collection</MenuItem>
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Weekly Stats Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>Weekly Stats</h2>
                </div>

                <div className="form gap_m">
                    <div className="control_group w_100">
                        <label>Select Stats to Display</label>
                        <div className="flex gap_m mt_10" style={{ flexWrap: 'wrap', gap: '16px' }}>
                            {[
                                { id: 'stat_orders_placed', value: '12.4K', label: 'Orders Placed' },
                                { id: 'stat_new_reviews', value: '2.4K', label: 'New Reviews' },
                                { id: 'stat_trending_products', value: '156', label: 'Trending Products' },
                                { id: 'stat_active_vendors', value: '1,240', label: 'Active Vendors' },
                                { id: 'stat_customer_satisfaction', value: '98%', label: 'Customer Satisfaction' },
                                { id: 'stat_on_time_delivery', value: '94%', label: 'On-Time Delivery' },
                                { id: 'stat_avg_delivery', value: '1.8 Days', label: 'Avg Delivery' },
                                { id: 'stat_licensed_sellers', value: '100', label: 'Licensed sellers' },
                            ].map((stat) => (
                                <div key={stat.id} style={{
                                    flex: '1 1 calc(25% - 16px)',
                                    minWidth: '200px',
                                    padding: '20px',
                                    borderRadius: '12px',
                                    border: '1px solid #e5e7eb',
                                    backgroundColor: '#ffffff',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    boxSizing: 'border-box'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                        <h3 style={{ margin: 0, fontSize: '26px', fontWeight: 700, color: '#111827', lineHeight: '1.2' }}>{stat.value}</h3>
                                        <input
                                            type="checkbox"
                                            id={stat.id}
                                            name={stat.id}
                                            style={{ width: '20px', height: '20px', cursor: 'pointer', margin: 0, marginTop: '2px', accentColor: '#000' }}
                                        />
                                    </div>
                                    <label htmlFor={stat.id} style={{ margin: 0, fontSize: '15px', color: '#6b7280', fontWeight: 500, cursor: 'pointer', display: 'block', width: '100%' }}>
                                        {stat.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="cards wrap_viewDemo_steps">
                <div className="title_inner">
                    <h2>CTA Section</h2>
                </div>

                <form className="form">
                    <div className="gap_m">
                        <div className="control_group w_100">
                            <label htmlFor="cta_upload">CTA Image</label>
                            <div className="upload_box">
                                <button type="button" id="cta_upload" className="upload_action" onClick={() => setOpenModal(true)} style={{background: 'transparent', border: 'none', width: '100%', padding: 0}}>
                                    <p>
                                        <img src="/static/images/upload_icon.svg" alt="icon" />
                                        <strong>Click to upload Image</strong>
                                    </p>
                                </button>
                            </div>
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="cta_title">CTA Title</label>
                            <TextField
                                id="cta_title"
                                placeholder="Enter CTA Title"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="cta_desc">CTA Description</label>
                            <TextField
                                id="cta_desc"
                                placeholder="Enter CTA Description"
                                fullWidth
                                multiline
                                rows={2}
                                hiddenLabel
                            />
                        </div>

                        <div className="control_group w_33">
                            <label htmlFor="cta_btn">CTA Button Text</label>
                            <TextField
                                id="cta_btn"
                                placeholder="Enter Button Text"
                                fullWidth
                                hiddenLabel
                            />
                        </div>
                    </div>
                </form>
            </div>

            {/* Save Button */}


            <SelectUpload
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
}

export default HomePageBanners;
